import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {useHistory} from "react-router-dom";

import TrackingNumberItem, {ICON_TAIL_LENGTH} from "./components/TrackingNumberItem";

import {navigateOnClick} from "utils/navigateOnClick";
import {OMSRoutes} from "utils/OMSRoutes";
import {greyishBlue500} from "assets/jss/main";

import {getShipmentTrackingNumbers} from "views/oms/OrderList/utils/getShipmentTrackingNumbers";
import {getReturnTrackingNumbers} from "views/oms/OrderList/utils/getReturnTrackingNumbers";

const MAX_TRACKING_LINES = 5;
const CHARS_PER_LINE = 14;

TrackingNumbers.propTypes = {
    orderId: PropTypes.string.isRequired,
    shipments: PropTypes.array,
    returns: PropTypes.array,
};

function estimateLineCount(trackingNumber) {
    // reserve room for the copy icon's nowrap tail (ICON_TAIL_LENGTH), which bumps the
    // estimate up a line whenever the number would otherwise exactly fill its last line
    return Math.max(1, Math.ceil((trackingNumber.length + ICON_TAIL_LENGTH) / CHARS_PER_LINE));
}

function TrackingNumbers({orderId, shipments = [], returns = []}) {
    const history = useHistory();
    const [copiedTrackingNumber, setCopiedTrackingNumber] = useState(null);

    function handleCopy(event, trackingNumber) {
        event.stopPropagation();
        navigator.clipboard.writeText(trackingNumber);
        setCopiedTrackingNumber(trackingNumber);
        setTimeout(() => setCopiedTrackingNumber(null), 1500);
    }

    const allTrackingNumbers = [
        ...getShipmentTrackingNumbers(shipments),
        ...getReturnTrackingNumbers(shipments, returns)
    ];

    const visibleTrackingNumbers = [];
    let lineCount = 0;
    let truncated = false;

    for (const item of allTrackingNumbers) {
        const itemLines = estimateLineCount(item.trackingNumber);

        if (lineCount + itemLines > MAX_TRACKING_LINES) {
            truncated = true;
            break;
        }

        visibleTrackingNumbers.push(item);
        lineCount += itemLines;
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
            {visibleTrackingNumbers.map(({trackingNumber, tooltip}) => (
                <TrackingNumberItem
                    key={trackingNumber}
                    trackingNumber={trackingNumber}
                    tooltip={tooltip}
                    copied={copiedTrackingNumber === trackingNumber}
                    onCopy={(e) => handleCopy(e, trackingNumber)}
                />
            ))}
            {truncated && (
                <span
                    style={{
                        color: greyishBlue500,
                        fontSize: '14px',
                        fontWeight: 400,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        navigateOnClick(e, OMSRoutes.ORDER(orderId), history);
                    }}
                >
                    <FormattedMessage id='retailer.product.list.stock.showMore' />
                </span>
            )}
        </div>
    );
}

export default TrackingNumbers;
